<template>
  <div>
    <el-checkbox-group v-model="checkList" @change="change">
      <el-checkbox :label="0">{{
        language("accountManagement.pick")
      }}</el-checkbox>
      <el-checkbox :label="1">{{
        language("accountManagement.delivered")
      }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      checkList: [],
    };
  },
  watch: {
    formData: {
      handler() {
        console.log(this.formData);
        if (this.formData && this.formData.deliverStatus) {
          this.checkList = this.formData.deliverStatus;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    change() {
      this.$emit("change", this.checkList);
    },
  },
  mounted() {},
};
</script>